export default __webpack_public_path__ + "static/media/teamwork.217c0d67.jpeg";